import { useEffect, useState } from "react";
import LayoutHeader from "../../../../../layout/LayoutHeader";
import { useDispatch, useSelector } from "react-redux";
import { setFocusMusic } from "../../../../../store/focuspage/focuspageSlice";
import { useNavigate } from "react-router";
import { setLoader, setErrorAlert } from "../../../../../store/alert/alertSlice";
import DizeeInput from "../../../../../components/DizeeComponent/DizeeInput";
import { uploadImage } from "../../../../../utils/upload";

export default function Step5() {
    const [preview, setPreview] = useState(null);
    const [file, setFile] = useState(null);
    const [headerTitle, setHeaderTitle] = useState('');
    const [headerSubtitle, setHeaderSubtitle] = useState('');
    
    let music = useSelector(state => state.focuspage.music);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        if (music?.avatarPreview) {
            setPreview(music?.avatarPreview);
        }
        if (music?.headerTitle) setHeaderTitle(music.headerTitle);
        if (music?.headerSubtitle) setHeaderSubtitle(music.headerSubtitle);
    }, [music]);

    const changeAvatar = (e) => {
        const selectedFile = e.target.files[0];
        if (selectedFile) {
            setFile(selectedFile);
            setPreview(URL.createObjectURL(selectedFile));
            dispatch(setFocusMusic({ 
                avatar: selectedFile,
                avatarPreview: URL.createObjectURL(selectedFile)
            }));
        }
    };

    const handleNext = async () => {
        if (!headerTitle || !headerSubtitle) {
            dispatch(setErrorAlert('Please fill in all header fields'));
            return;
        }

        dispatch(setFocusMusic({ 
            headerTitle,
            headerSubtitle,
            headeractive: true
        }));
        
        if (music?.type === 'multiple') {
            navigate("/focus-page/music-type/multi-step6");
        } else {
            navigate("/focus-page/music-type/step7");
        }
    };

    return (
        <LayoutHeader>
            <div className="flex justify-center w-full">
                <div className="w-[390px] h-[80vh] flex flex-col items-center relative z-[0]">
                    <div className="px-4 my-[50px] flex w-full justify-between">
                        <p className="text-white">Add header image</p>
                        <div className="flex gap-[30px]">
                            <div
                                className={`text-white cursor-pointer ${file || music?.avatar ? "opacity-100" : "opacity-50"}`}
                                onClick={handleNext}
                            >
                                Next
                            </div>
                            <div 
                                className="text-white cursor-pointer"
                                onClick={() => navigate("/focus-page/music-type/step4")}
                            >
                                Go back
                            </div>
                        </div>
                    </div>

                    <div className="w-full px-4">
                        <div
                            className="text-white cursor-pointer"
                            onClick={() => document.getElementById("avatar").click()}
                        >
                            {preview ? "Change header image" : "Upload header image"}
                        </div>
                        <input
                            type="file"
                            accept="image/*"
                            className="hidden"
                            id="avatar"
                            onChange={changeAvatar}
                        />
                        {preview ? (
                            <div className="profile-picture my-8 min-h-[100px]">
                                <div className="avatar">
                                    <img
                                        src={preview}
                                        className="h-[80px] w-[80px] rounded-full"
                                        alt="header"
                                    />
                                </div>
                            </div>
                        ) : (
                            <div className="mb-8" />
                        )}

                        <div className="mt-6">
                            <DizeeInput
                                placeholder="Add header title"
                                onChange={(e) => setHeaderTitle(e.target.value)}
                                value={headerTitle}
                                className="w-full"
                            />
                        </div>

                        <div className="mt-6">
                            <DizeeInput
                                placeholder="Add header subtitle"
                                onChange={(e) => setHeaderSubtitle(e.target.value)}
                                value={headerSubtitle}
                                className="w-full"
                            />
                        </div>
                    </div>

                    <div className="w-full px-4 absolute bottom-[27px] left-0">
                        <div className="text-[12px] text-[rgba(255,255,255,0.5)] leading-[1.5] max-w-full">
                            <p>Upload an image for your focus page header.</p>
                            <p>Add title and subtitle to display in the header area.</p>
                        </div>
                    </div>
                </div>
            </div>
        </LayoutHeader>
    );
}

